const Error = () => {
    return <img alt="Error" className="error" src="https://pbs.twimg.com/media/DVoDShnWkAAXODS.jpg"></img>;
}

export default Error;